<div class="banner" fxLayoutAlign="center center">
	<div class="banner-box">
		<div class="caption">
			<h1><ng-content select="[caption]"></ng-content></h1>
		</div>
		<div class="subcaption">
			<ng-content select="[subcaption]"></ng-content>
		</div>
	</div>
</div>
